import React from 'react';
import TextWinds from '../common/TextWinds';
import { Spinner } from '@material-tailwind/react';

interface SpinnerProps {
  message?: string;
}

/**
 * 로딩 스피너
 * @description 로딩 스피너
 * @param message 메시지
 * @returns 로딩 스피너
 */
export const LoadingSpinner = ({ message }: SpinnerProps) => {
  return (
    <div>
      <Spinner />
      <TextWinds type="title_h6">{message}</TextWinds>
    </div>
  );
};
